import React, { useState, useEffect, useContext } from 'react'
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import {getTaxGroupList} from "../../Services/Packages.service";
import { getCarTypes, getCorporateClientsBySeviceCityIdWithoutPagination, showAlert } from "../../Services/Shared.service";
import { ArrowDown, ArrowUp } from "react-feather";
import { CommonModal } from "../../AbstractElements";
import { addMonths, addSeconds } from "date-fns";
import { createRate, getRate, updateRate } from "../../Services/Rates.service";
import { useRateConstraints, validatePerKmCharge } from "../../hooks/useRateConstraints";
import moment from "moment";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import SharedDataContext from "../../_helper/SharedData";
import AsyncSelect from 'react-select/async';
import { Button } from '@mui/material';
import AddBoxIcon from "@mui/icons-material/AddBox";
// import PackageRateCalendar from '../PackageRates/PackageRateCalendar';
import RateCalendarByCity from '../RateCalenderByCity/RateCalendarByCity';
import Rates from '../Rates';
import { useTariffSearch } from '../../_helper/TariffSearchContext/TariffSeachContext';

function MeterForms({ taxArr, setTitle }) {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
    } = useForm({
        defaultValues: {
            timeFrom: "",
            timeTo: "",
            isActive: true,
            initialDist: "",
            initialDistCharge: "",
            perKmCharge: "",
            waitingChargePerMin: "",
            waitingChargeAfterTimeInMin: "",
            tripTimeChargePerMin: "",
            waitingCalcThresholdSpeed: "",
            serviceCity: {},
            baseFareTax: {},
            serviceTax: {},
            corporateClient: {},
            carTypeDropdown: {},
            discountLocationId: "",
            isNightfareTimeSlot: false,
            applicableFromDate: new Date(),
            applicableToDate: addMonths(new Date(), 1),
            airportDropdown: {},
            bookingSource: "",
            rideType: "",
            isPriority: false
        },
    });
    const values = getValues()
    const [loader, setLoader] = useState(false);
    const [taxData, setTaxData] = useState([]);
    const [corporateClientData, setCorporateClientData] = useState([]);
    const [carTypeData, setCarTypeData] = useState([]);
    const [airportCityData, setAirportCityData] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [rateObj, setRateObj] = useState({})
    const [isAdvanced, setIsAdvanced] = useState(false)
    // const[editId,setEditId] = useState();
    // const[isExistin,setExisting] = useState()
    const {mix_background_layout} = useContext(CustomizerContext)
    const {setCloseInputModal} = useTariffSearch();
    const { cityData, globalCityField, setShowApiLoader, airportData } =
        useContext(SharedDataContext);
    const[isNew,setNew] = useState(false)
    const[isExisting,setIsExisting] = useState(false)
    const[isSearch,setIsSearch] = useState(true)
    const[citySelected,setCitySelected] = useState()
    const[calendarView,setCalendarView] = useState(false)
    const[cityId,setCityId] = useState()
    const[combinedTax,setCombinedTax] = useState([])
    const[selectedTax,setSelectedTax] = useState(null)
    const [rateEntries, setRateEntries] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);
    const MAX_ENTRIES = 6; // Maximum number of entries allowed at one time
    const rewardConstraints = useRateConstraints();

    useEffect(() => {
        getTaxGroupList().then((result) => {
            if (result.status == 200) {
                setCombinedTax(generateTaxCombinationsForSelectBox(result.data));
            }
        });
      }, [])
    
      function generateTaxCombinationsForSelectBox(taxData) {
        let basezero= taxData.filter( t => t.taxRate === 0);
        let basenonzero= taxData.filter( t => t.taxRate !==0);
        console.log("Base Zero :" ,basezero);
        basezero.sort((a,b)=> a.taxCategory.localeCompare(b.taxCategory));
        basenonzero.sort((a,b)=> a.taxCategory.localeCompare(b.taxCategory));
        let combinations = [];
        combinations.push({
            label:`Base ${basenonzero[0].taxRate}% Service ${basenonzero[1].taxRate}%`,
            value:{baseTax:basenonzero[0],serviceTax:basenonzero[1]}
        })
        combinations.push({
            label:`Base ${basezero[0].taxRate}% Service ${basezero[1].taxRate}%`,
            value:{baseTax:basezero[0],serviceTax:basezero[1]}
        })
      
        return combinations;
      }



    const bookingSourceData = [
        { value: "Partner", label: "Partner" },
        { value: "Customer", label: "Customer" },
        { value: "Kiosk", label: "Kiosk" },
        { value: "Website", label: "Website" },
        { value: "TMS", label: "TMS" },
        { value: "ThirdParty", label: "ThirdParty" },
        { value: "ALL", label: "ALL" },
    ]

    const rideTypeData = [
        { value: "RideLater", label: "C2A" },
        { value: "KurbPickup", label: "KurbPickup" },
        { value: "AirportPickup", label: "A2C" },
        { value: "ALL", label: "ALL" },
    ]

    const isActiveField = useController({
        name: "isActive",
        control,
    }).field;

    const isPriorityField = useController({
        name: "isPriority",
        control,
    }).field;

    const isNightfareTimeSlotField = useController({
        name: "isNightfareTimeSlot",
        control,
    }).field;

    const serviceCityField = useController({
        name: "serviceCity",
        control,
        rules: {
            required: {
                value: true,
                message: "Service City is Required",
            },
        validate: (value) => {
          // Check if the object has an id (meaning a city was actually selected)
          if (!value || !value.id) {
            return "Service City is Required";
          }
          return true;
        },
      },
    }).field;

    const handleServiceCitySelectChange = (data) => {
        serviceCityField.onChange(data.value);
        carTypeField.onChange({});
        airportField.onChange({});
    };

        const baseFareTaxField = useController({
        name: "baseFareTax",
        control,
        rules: {
            required: {
                value: true,
                message: "Tax is Required",
            },
            validate: (value) => {
                // Check if the object has taxGroupId (meaning a tax was actually selected)
                if (!value || !value.taxGroupId) {
                    return "Tax is Required";
                }
                return true;
            }
        },
    }).field;

    const handleBaseFareTax = (data) => {
        baseFareTaxField.onChange(data.value);
    };

    const serviceTaxField = useController({
        name: "serviceTax",
        control,
        rules: {
            // required: {
            //     value: true,
            //     message: "Service Tax is Required",
            // },
        },
    }).field;

    const handleServiceFareTax = (data) => {
        serviceTaxField.onChange(data.value);
    };

    const corporateClientField = useController({
        name: "corporateClient",
        control,
        rules: {
            // required: {
            //     value: true,
            //     message: "Corporate Client is Required",
            // },
        },
    }).field;

    const handleCorporateClientSelectChange = (data) => {
        corporateClientField.onChange(data.value);
    };

    const applicableToDateField = useController({
      name: "applicableToDate",
      control,
      rules: {
        required: {
          value: true,
          message: "Applicable To Date is Required",
        },
        validate: (value) => {
          const from = applicableFromDateField.value; // THE FROM DATE
          if (from && value && value < from) {
            return "Available To Date cannot be earlier than Available From Date";
          }
          return true;
        },
      },
    }).field;


    const handleApplicableToDate = (data) => {
        applicableToDateField.onChange(data);
    };

    const applicableFromDateField = useController({
        name: "applicableFromDate",
        control,
        rules: {
            required: {
                value: true,
                message: "Applicable From Date is Required",
            },
        },
    }).field;

    const handleApplicableFromDate = (data) => {
        applicableFromDateField.onChange(data);
    };

    const carTypeField = useController({
        name: "carTypeDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Car type is Required",
            },
        validate: (value) => {
          if (!value || !value.id) {
            return "Car type is Required";
          }
          return true;
        },
      },
    }).field;

    const handleCarTypeSelectChange = (data) => {
        carTypeField.onChange(data.value);
    };

    const bookingSourceField = useController({
        name: "bookingSource",
        control,
        rules: {
            required: {
                value: true,
                message: "Booking Source is Required",
            },
        },
    }).field;

    const handleBookingSourceSelectChange = (data) => {
        bookingSourceField.onChange(data.value);
    };

    const rideTypeField = useController({
        name: "rideType",
        control,
        rules: {
            required: {
                value: true,
                message: "Ride Type is Required",
            },
        },
    }).field;

    const handleRideTypeSelectChange = (data) => {
        rideTypeField.onChange(data.value);
    };

    const timeFromField = useController({
        name: "timeFrom",
        control,
        rules: {
            required: {
                value: true,
                message: "Time From is Required",
            },
        },
    }).field;

    const handleTimeFrom = (data) => {
        timeFromField.onChange(data);
    };

    const timeToField = useController({
      name: "timeTo",
      control,
      rules: {
        required: {
          value: true,
          message: "Time To is Required",
        },
        validate: (value) => {
          if (!value || !timeFromField.value) return true; // skip if no data yet

          const from = new Date(timeFromField.value).getHours();
          const to = new Date(value).getHours();

          // Allow ONLY 12 AM → 12 AM
          if (from === 0 && to === 0) return true;

          // Reject same time (except 12→12)
          if (from === to) return "Start time and end time cannot be the same";

          // Reject lesser time
          if (to != 0 && to < from) return "Time To should be greater than Time From";

          return true;
        },
      },
    }).field;


    const handleTimeTo = (data) => {
        timeToField.onChange(data);
    };

    const airportField = useController({
        name: "airportDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Airport is Required",
            },
            validate: (value) => {
                if (!value || !value.id) {
                    return "Airport is Required";
                }
                return true;
            }
        }
    }).field;

    const handleAirportSelectChange = (data) => {
        airportField.onChange(data.value);
    };

    useEffect(() => {
        const serviceCityId = serviceCityField.value?.id;
        if (!serviceCityId) {
            setCarTypeData([]);
            return;
        }
        let array = [];
        airportData.forEach((element) => {
            if (element.serviceCityId == serviceCityId) {
                array.push({
                    value: element,
                    label: element.name,
                });
            }
        });
        setAirportCityData(array);
        let obj = {
            serviceCityId,
            // travelType: rideTypeField.value == "AirportPickup" ? "A2C" : "C2A",
            // travelType: "A2C"
        };
        getCarTypes(obj)
            .then((result) => {
                const data = result.data.map((element) => {
                    return {
                        label: element.name,
                        value: element,
                    };
                });
                setCarTypeData(data);
            })
            .catch((err) => {
                showAlert("error", "Unable to fetch Car details for selected City");
            });

    getCorporateClientsBySeviceCityIdWithoutPagination(obj).then((result) => {
      if (result.status == 200) {
        const data = result.data.list.map((element) => {
          return {
            value: element,
            label: element.companyName,
          };
        });
        setCorporateClientData(data);
      }
    });
  }, [serviceCityField.value]);
  const handleTime_To = (time, constraint) => {
    let timeto =
      constraint == "S"
        ? Number(moment.duration(moment(time).format("HH:mm:ss")).asSeconds())
        : Number(moment.duration(moment(time).format("HH:mm:ss")).asMinutes());
    if (timeto === 0 && constraint == "S") {
      return 86400;
    } else if (timeto === 0 && constraint == "M") {
      return 1440;
    }
    return timeto;
  };
  // const onFormSubmit = (formValues) => {
  //   setIsSubmitting(true);
  //   const body = {
  //     timeFrom: formValues.timeFrom
  //       ? Number(
  //           moment
  //             .duration(moment(formValues.timeFrom).format("HH:mm:ss"))
  //             .asSeconds()
  //         )
  //       : 0,
  //     timeTo: formValues.timeTo ? handleTime_To(formValues.timeTo, "S") : 0,
  //     isActive: formValues.isActive ? true : false,
  //     initialDist: formValues.initialDist ? Number(formValues.initialDist) : 0,
  //     initialDistCharge: formValues.initialDistCharge
  //       ? Number(formValues.initialDistCharge)
  //       : 0,
  //     perKmCharge: formValues.perKmCharge ? Number(formValues.perKmCharge) : 0,
  //     waitingChargePerMin: formValues.waitingChargePerMin
  //       ? Number(formValues.waitingChargePerMin)
  //       : 0,
  //     waitingChargeAfterTimeInMin: formValues.waitingChargeAfterTimeInMin
  //       ? Number(formValues.waitingChargeAfterTimeInMin)
  //       : 0,
  //     tripTimeChargePerMin: formValues.tripTimeChargePerMin
  //       ? Number(formValues.tripTimeChargePerMin)
  //       : 0,
  //     waitingCalcThresholdSpeed: formValues.waitingCalcThresholdSpeed
  //       ? Number(formValues.waitingCalcThresholdSpeed)
  //       : 0,
  //     serviceCityId: formValues.serviceCity?.id
  //       ? formValues.serviceCity.id
  //       : null,
  //     serviceCityName: formValues.serviceCity?.name
  //       ? formValues.serviceCity.name
  //       : "",
  //     baseFareTaxId: formValues.baseFareTax?.taxGroupId
  //       ? formValues.baseFareTax.taxGroupId
  //       : "",
  //     baseFareTaxName: formValues.baseFareTax?.name
  //       ? formValues.baseFareTax.name
  //       : "",
  //     corporateClientId: formValues.corporateClient?.id
  //       ? formValues.corporateClient.id
  //       : null,
  //     corporateClientName: formValues.corporateClient?.companyName
  //       ? formValues.corporateClient.companyName
  //       : null,
  //     discountLocationId: formValues.discountLocationId
  //       ? formValues.discountLocationId
  //       : null,
  //     isNightfareTimeSlot: formValues.isNightfareTimeSlot ? true : false,
  //     serviceTaxName: formValues.serviceTax?.name
  //       ? formValues.serviceTax.name
  //       : "",
  //     carTypeId: formValues.carTypeDropdown?.id
  //       ? formValues.carTypeDropdown.id
  //       : 0,
  //     carTypeName: formValues.carTypeDropdown?.name
  //       ? formValues.carTypeDropdown.name
  //       : "Any",
  //     serviceTaxId: formValues.serviceTax?.taxGroupId
  //       ? formValues.serviceTax.taxGroupId
  //       : "",
  //     applicableFromDate: formValues?.applicableFromDate
  //       ? new Date(formValues?.applicableFromDate)
  //       : "",
  //     applicableToDate: formValues?.applicableToDate
  //       ? new Date(formValues?.applicableToDate)
  //       : "",
  //     airportId: formValues.airportDropdown?.id
  //       ? formValues.airportDropdown.id
  //       : "",
  //     bookingSource: formValues.bookingSource ? formValues.bookingSource : "",
  //     rideType: formValues.rideType ? formValues.rideType : "",
  //     isPriority: formValues?.isPriority ? formValues?.isPriority : false,
  //   };
  //   if (rateObj?.id) {
  //     body["id"] = rateObj?.id;
  //     updateRate(body)
  //       .then((result) => {
  //         reset({
  //           timeFrom: "",
  //           timeTo: "",
  //           isActive: true,
  //           initialDist: "",
  //           initialDistCharge: "",
  //           perKmCharge: "",
  //           waitingChargePerMin: "",
  //           waitingChargeAfterTimeInMin: "",
  //           tripTimeChargePerMin: "",
  //           waitingCalcThresholdSpeed: "",
  //           serviceCity: {},
  //           baseFareTax: {},
  //           serviceTax: {},
  //           corporateClient: {},
  //           carTypeDropdown: {},
  //           discountLocationId: "",
  //           isNightfareTimeSlot: false,
  //           applicableFromDate: new Date(),
  //           applicableToDate: addMonths(new Date(), 1),
  //           airportDropdown: {},
  //           bookingSource: "",
  //           rideType: "",
  //           isPriority: false,
  //         });
  //         showAlert("success", "Rate Updated Successfully");
  //         // fetchTableData();
  //         setIsSubmitting(false);
  //         // setEditId("")
  //         setRateObj({});
  //         // setIsOpen(false)
  //       })
  //       .catch((err) => {
  //         showAlert(
  //           "error",
  //           err.response?.data?.message
  //             ? err.response.data.message
  //             : "Something went wrong"
  //         );
  //         setIsSubmitting(false);
  //       });
  //   } else {
  //     createRate({ rates: [body] })
  //       .then((result) => {
  //         reset({
  //           timeFrom: "",
  //           timeTo: "",
  //           isActive: true,
  //           initialDist: "",
  //           initialDistCharge: "",
  //           perKmCharge: "",
  //           waitingChargePerMin: "",
  //           waitingChargeAfterTimeInMin: "",
  //           tripTimeChargePerMin: "",
  //           waitingCalcThresholdSpeed: "",
  //           serviceCity: {},
  //           baseFareTax: {},
  //           serviceTax: {},
  //           corporateClient: {},
  //           carTypeDropdown: {},
  //           discountLocationId: "",
  //           isNightfareTimeSlot: false,
  //           applicableFromDate: new Date(),
  //           applicableToDate: addMonths(new Date(), 1),
  //           airportDropdown: {},
  //           bookingSource: "",
  //           rideType: "",
  //           isPriority: false,
  //         });
  //         showAlert("success", "Rate Created Successfully");
  //         // fetchTableData();
  //         // setIsSubmitting(false)
  //         // setIsOpen(false)
  //       })
  //       .catch((err) => {
  //         showAlert(
  //           "error",
  //           err.response?.data?.message
  //             ? err.response.data.message
  //             : "Something went wrong"
  //         );
  //         setIsSubmitting(false);
  //       });
  //   }
  // };
  const convertTimeToSeconds = (time) => {
    const hr = Number(moment(time).format("HH"));
    const min = Number(moment(time).format("mm"));
    const sec = Number(moment(time).format("ss"));
  
    return hr * 3600 + min * 60 + sec;
  };
  const normalizeTime = (time) => {
    return convertTimeToSeconds(time); // 12 AM stays 0
  };
  const onFormSubmit = (formValues) => {
    console.log("form values", formValues);
    let timeFromSeconds = formValues.timeFrom
      ? Number(
          moment
            .duration(moment(formValues.timeFrom).format("HH:mm:ss"))
            .asSeconds()
        )
      : 0;

    let timeToSeconds = formValues.timeTo
      ? handleTime_To(formValues.timeTo, "S")
      : 0;
    const timeFromDisplay = formValues.timeFrom 
    ? moment(formValues.timeFrom).format("h:mm A")
      : "";
    const timeToDisplay = formValues.timeTo 
    ? (handleTime_To(formValues.timeTo, "S") === 86400 
        ? "12:00 AM" 
        : moment(formValues.timeTo).format("h:mm A"))
    : "";
    const rateEntry = {
      timeFrom: timeFromSeconds,
      timeFromDisplay: timeFromDisplay,
      timeTo: timeToSeconds,
      timeToDisplay: timeToDisplay,
      isActive: formValues.isActive ? true : false,
      initialDist: formValues.initialDist ? Number(formValues.initialDist) : 0,
      initialDistCharge: formValues.initialDistCharge
        ? Number(formValues.initialDistCharge)
        : 0,
      perKmCharge: formValues.perKmCharge ? Number(formValues.perKmCharge) : 0,
      waitingChargePerMin: formValues.waitingChargePerMin
        ? Number(formValues.waitingChargePerMin)
        : 0,
      waitingChargeAfterTimeInMin: formValues.waitingChargeAfterTimeInMin
        ? Number(formValues.waitingChargeAfterTimeInMin)
        : 0,
      tripTimeChargePerMin: formValues.tripTimeChargePerMin
        ? Number(formValues.tripTimeChargePerMin)
        : 0,
      waitingCalcThresholdSpeed: formValues.waitingCalcThresholdSpeed
        ? Number(formValues.waitingCalcThresholdSpeed)
        : 0,
      serviceCityId: formValues.serviceCity?.id
        ? formValues.serviceCity.id
        : null,
      serviceCityName: formValues.serviceCity?.name
        ? formValues.serviceCity.name
        : "",
      baseFareTaxId: formValues.baseFareTax?.taxGroupId
        ? formValues.baseFareTax.taxGroupId
        : "",
      baseFareTaxName: formValues.baseFareTax?.taxCategory
        ? formValues.baseFareTax.taxCategory
        : "",
      baseFareTaxRate: formValues.baseFareTax?.taxRate
        ?? formValues.baseFareTax.taxRate,
      corporateClientId: formValues.corporateClient?.id
        ? formValues.corporateClient.id
        : null,
      corporateClientName: formValues.corporateClient?.companyName
        ? formValues.corporateClient.companyName
        : null,
      discountLocationId: formValues.discountLocationId
        ? formValues.discountLocationId
        : null,
      isNightfareTimeSlot: formValues.isNightfareTimeSlot ? true : false,
      serviceTaxName: formValues.serviceTax?.taxCategory
        ? formValues.serviceTax.taxCategory
        : "",
      serviceTaxRate: formValues.serviceTax?.taxRate
        ?? formValues.serviceTax.taxRate,
      carTypeId: formValues.carTypeDropdown?.id
        ? formValues.carTypeDropdown.id
        : 0,
      carTypeName: formValues.carTypeDropdown?.name
        ? formValues.carTypeDropdown.name
        : "Any",
      serviceTaxId: formValues.serviceTax?.taxGroupId ? formValues.serviceTax.taxGroupId : "",
      applicableFromDate: formValues?.applicableFromDate
        ? new Date(formValues?.applicableFromDate)
        : "",
      applicableToDate: formValues?.applicableToDate
        ? new Date(formValues?.applicableToDate)
        : "",
      airportId: formValues.airportDropdown?.id
        ? formValues.airportDropdown.id
        : "",
      terminal: formValues.airportDropdown?.shortName
        ? formValues.airportDropdown.shortName
        : "",
      airportName: formValues.airportDropdown?.name
        ? formValues.airportDropdown.name
        : "",
      bookingSource: formValues.bookingSource ? formValues.bookingSource : "",
      rideType: formValues.rideType ? formValues.rideType : "",
      isPriority: formValues?.isPriority ? formValues?.isPriority : false,
    };
    console.log('single rate entry:', rateEntry)
    if (formValues.timeFrom && formValues.timeTo) {
      let nf = timeFromSeconds; // start seconds
      let nt = timeToSeconds; // end seconds
      // Full-day 12 AM → 12 AM
      const isFullDay = nf === 0 && nt === 0;
      if (isFullDay) nt = 86400;
      // Rule 1 — Start and end cannot be same (except full day)
      if (nf === nt && !isFullDay) {
        showAlert("error", "Start time and End time cannot be the same");
        return;
      }
      // Rule 2 — End must be greater
      if (nt <= nf && !isFullDay) {
        showAlert("error", "End time must be greater than Start time");
        return;
      }

      // Rule 3 — Overlap detection
      for (let i = 0; i < rateEntries.length; i++) {
        if (editingIndex !== null && i === editingIndex) continue;

        const e = rateEntries[i];
        const ef = Number(e.timeFrom);
        const et = Number(e.timeTo);

        // Unified final overlap logic
        const overlap = Math.max(nf, ef) < Math.min(nt, et);
        if (overlap) {
          showAlert(
            "error",
            `Time range overlaps with existing package rate (${e.timeFromDisplay} to ${e.timeToDisplay}).`
          );
          return;
        }
      }
    }


    if (editingIndex !== null) {
      // Update existing entry
      const updatedEntries = [...rateEntries];
      updatedEntries[editingIndex] = rateEntry;
      setRateEntries(updatedEntries);
      setEditingIndex(null);
      showAlert("success", "Rate entry updated successfully");
    } else {
      // Check if maximum entries limit is reached
      if (rateEntries.length >= MAX_ENTRIES) {
        showAlert("error", `You can only create up to ${MAX_ENTRIES} entries at one time. Please submit the current entries before adding more.`);
        return;
      }
      // Add new entry
      setRateEntries([...rateEntries, rateEntry]);
      showAlert("success", "Rate entry added successfully");
    }

    // Reset form
          reset({
            timeFrom: "",
            timeTo: "",
            isActive: true,
            initialDist: "",
            initialDistCharge: "",
            perKmCharge: "",
            waitingChargePerMin: "",
            waitingChargeAfterTimeInMin: "",
            tripTimeChargePerMin: "",
            waitingCalcThresholdSpeed: "",
            serviceCity: {},
            baseFareTax: {},
            serviceTax: {},
            corporateClient: {},
            carTypeDropdown: {},
            discountLocationId: "",
            isNightfareTimeSlot: false,
            applicableFromDate: new Date(),
            applicableToDate: addMonths(new Date(), 1),
            airportDropdown: null,
            bookingSource: "",
            rideType: "",
            isPriority: false,
          });
    setSelectedTax(null);

};

  const submitAllRates = async () => {
      if (rateEntries.length === 0) {
        showAlert("error", "Please add at least one rate entry");
        return;
      }

      setIsSubmitting(true);
      
      try {
        // Submit all rates sequentially
        const body = rateEntries.map((entry) => ({
          timeFrom: entry.timeFrom,
          timeTo: entry.timeTo,
          isActive: entry.isActive,
          initialDist: entry.initialDist,
          initialDistCharge: entry.initialDistCharge,
          perKmCharge: entry.perKmCharge,
          waitingChargePerMin: entry.waitingChargePerMin,
          waitingChargeAfterTimeInMin: entry.waitingChargeAfterTimeInMin,
          tripTimeChargePerMin: entry.tripTimeChargePerMin,
          waitingCalcThresholdSpeed: entry.waitingCalcThresholdSpeed,
          serviceCityId: entry.serviceCityId,
          serviceCityName: entry.serviceCityName,
          baseFareTaxId: entry.baseFareTaxId,
          baseFareTaxName: entry.baseFareTaxName,
          corporateClientId: entry.corporateClientId,
          corporateClientName: entry.corporateClientName,
          discountLocationId: entry.discountLocationId,
          isNightfareTimeSlot: entry.isNightfareTimeSlot,
          serviceTaxName: entry.serviceTaxName,
          carTypeId: entry.carTypeId,
          carTypeName: entry.carTypeName,
          serviceTaxId: entry.serviceTaxId,
          applicableFromDate: entry.applicableFromDate,
          applicableToDate: entry.applicableToDate,
          airportId: entry.airportId,
          terminal: entry.terminal,
          bookingSource: entry.bookingSource,
          rideType: entry.rideType,
          isPriority: entry.isPriority,
        }));
      
        await createRate({ rates: body });
        setCloseInputModal(false);
        showAlert("success", `${rateEntries.length} Rate(s) Created Successfully`);
        setRateEntries([]);
        setIsSubmitting(false);
      } catch (err) {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
        setIsSubmitting(false);
      }
  };
  
  const handleEditEntry = (index) => {
    const entry = rateEntries[index];
    setEditingIndex(index);
    console.log('selected entry data:',entry)
    // Populate form with entry data
    setValue(
      "timeFrom",
      entry.timeFrom !== null && entry.timeFrom !== undefined
        ? addSeconds(new Date().setHours(0, 0, 0, 0), entry.timeFrom)
        : ""
    );
    setValue(
      "timeTo",
      entry.timeTo
        ? addSeconds(new Date().setHours(0, 0, 0, 0), entry.timeTo)
        : ""
    );
    setValue("isActive", entry.isActive);
    setValue("initialDist", entry.initialDist);
    setValue("initialDistCharge", entry.initialDistCharge);
    setValue("perKmCharge", entry.perKmCharge);
    setValue("waitingChargePerMin", entry.waitingChargePerMin);
    setValue("waitingChargeAfterTimeInMin", entry.waitingChargeAfterTimeInMin);
    setValue("tripTimeChargePerMin", entry.tripTimeChargePerMin);
    setValue("waitingCalcThresholdSpeed", entry.waitingCalcThresholdSpeed);
    setValue("serviceCity", {
      id: entry.serviceCityId,
      name: entry.serviceCityName,
    });
    setValue("baseFareTax", {
      taxGroupId: entry.baseFareTaxId,
      taxCategory: entry.baseFareTaxName,
      taxRate: entry.baseFareTaxRate
    });
    setValue("serviceTax", {
      taxGroupId: entry.serviceTaxId,
      taxCategory: entry.serviceTaxName,
      taxRate: entry.serviceTaxRate
    });
    setValue(
      "corporateClient",
      entry.corporateClientId
        ? {
            id: entry.corporateClientId,
            companyName: entry.corporateClientName,
          }
        : {}
    );
    setValue("carTypeDropdown", {
      id: entry.carTypeId,
      name: entry.carTypeName,
    });
    setValue("discountLocationId", entry.discountLocationId);
    setValue("isNightfareTimeSlot", entry.isNightfareTimeSlot);
    setValue(
      "applicableFromDate",
      entry.applicableFromDate ? new Date(entry.applicableFromDate) : new Date()
    );
    setValue(
      "applicableToDate",
      entry.applicableToDate
        ? new Date(entry.applicableToDate)
        : addMonths(new Date(), 1)
    );
    setValue(
      "airportDropdown",
      entry.airportId ? { id: entry.airportId, shortName: entry.terminal, name: entry.airportName } : {}
    );
    setValue("bookingSource", entry.bookingSource);
    setValue("rideType", entry.rideType);
    setValue("isPriority", entry.isPriority);
    const matchedTax = combinedTax.find((option) => {
      return (
        option.value.baseTax.taxGroupId === entry.baseFareTaxId &&
        option.value.serviceTax.taxGroupId === entry.serviceTaxId
      );
    });

    setSelectedTax(matchedTax || null);
    // setSelectedTax(entry.)

    // Scroll to form
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleRemoveEntry = (index) => {
    const updatedEntries = rateEntries.filter((_, i) => i !== index);
    setRateEntries(updatedEntries);
    showAlert("success", "Rate entry removed");
    
    // If editing this entry, cancel edit mode
    if (editingIndex === index) {
      setEditingIndex(null);
      reset();
    }
  };
  const handleCancelEdit = () => {
    setEditingIndex(null);
          reset({
            timeFrom: "",
            timeTo: "",
            isActive: true,
            initialDist: "",
            initialDistCharge: "",
            perKmCharge: "",
            waitingChargePerMin: "",
            waitingChargeAfterTimeInMin: "",
            tripTimeChargePerMin: "",
            waitingCalcThresholdSpeed: "",
            serviceCity: {},
            baseFareTax: {},
            serviceTax: {},
            corporateClient: {},
            carTypeDropdown: {},
            discountLocationId: "",
            isNightfareTimeSlot: false,
            applicableFromDate: new Date(),
            applicableToDate: addMonths(new Date(), 1),
            airportDropdown: null,
            bookingSource: "",
            rideType: "",
            isPriority: false,
          });
    setSelectedTax(null);

};
  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };


    const handleClickNew =()=>{
        setTitle("Create Meter")
        setIsSearch(false);
        setIsExisting(false);
        setNew(true)
    }

    const handleExistClick =()=>{
        setTitle("Edit Meter")
        setIsSearch(false);
        setIsExisting(true);
        setNew(false);
    }

    const handleCityChange = (e)=>{
        console.log("selected city id",e.value.id)
        setCitySelected(e.value)

        setCityId(e.value.id)
        setIsExisting(false)
        setNew(false);
        setCalendarView(true);
        
    }

  return (
    <>
    <div>
      {/* {isSearch?<div
                style={{
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center"
                }}
                >
        
                <div 
                style={{
                    width:"400px",
                    display:"flex",
                    flexDirection:"column",
                    gap:"20px",
                }}
                >
        
                    <Button
                    sx={{
                      width: "100%",
                      fontSize: "1rem",
                      color: "#41CC7D",
                      borderColor: "#41CC7D",
                      "&:hover": {
                        borderColor: "#41CC7D",
                      },
                    }}
                    variant="outlined"
                    startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
                    onClick={handleClickNew}
                  >
                    New Meter Rates
                  </Button>
                  <Button
                    sx={{
                      width: "100%",
                      fontSize: "1rem",
                      color: "#41CC7D",
                      borderColor: "#41CC7D",
                      "&:hover": {
                        borderColor: "#41CC7D",
                      },
                    }}
                    variant="outlined"
                    startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
                    onClick={handleExistClick}
                  >
                    Existing Meter Rates
                  </Button>
               
                </div>
            </div>:null} */}
      {/* existing flow for meter */}
      {/* {isExisting?
            <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
               <div style={{width:"20rem"}}>
               <Select
                value={citySelected}
                options={cityData}
                onChange={handleCityChange}
                />
               </div>
            </div>:null} */}

      {calendarView ? (
        // <RateCalendarByCity serviceCityId={citySelected.id}/>:null
        <Rates serviceCityId={citySelected.id} />
      ) : null}

      <Form onSubmit={handleSubmit(onFormSubmit)}>
        <Row>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Service City</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    serviceCityField?.value?.id
                      ? cityData.find((element) => {
                          return (
                            element?.value?.id === serviceCityField?.value?.id
                          );
                        })
                      : ""
                  }
                  isDisabled={rateObj?.id ? true : false}
                  onChange={handleServiceCitySelectChange}
                  placeholder="Select City"
                  options={cityData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.serviceCity?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Car Type</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    carTypeField?.value?.id
                      ? carTypeData.find((element) => {
                          return element?.value?.id === carTypeField?.value?.id;
                        })
                      : ""
                  }
                  isDisabled={serviceCityField?.value?.id ? false : true}
                  onChange={handleCarTypeSelectChange}
                  placeholder={
                    serviceCityField?.value?.id
                      ? "Select Car Type"
                      : "Select city to select car type"
                  }
                  options={carTypeData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.carTypeDropdown?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Ride Type</Label>
            <Col lg="12">
              <div className="city-select">
                <Select
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    rideTypeField?.value
                      ? rideTypeData.find((element) => {
                          return element?.value === rideTypeField?.value;
                        })
                      : ""
                  }
                  onChange={handleRideTypeSelectChange}
                  placeholder="Select Ride Type"
                  options={rideTypeData}
                />
              </div>
              <span style={{ color: "red" }}>{errors?.rideType?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Booking Source</Label>
            <Col lg="12">
              <div className="city-select">
                <Select
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    bookingSourceField?.value
                      ? bookingSourceData.find((element) => {
                          return element?.value === bookingSourceField?.value;
                        })
                      : ""
                  }
                  onChange={handleBookingSourceSelectChange}
                  placeholder="Select Booking Source"
                  options={bookingSourceData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.bookingSource?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Airport</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  isDisabled={serviceCityField?.value?.id ? false : true}
                  value={airportField?.value?.id ?  airportCityData.find((element) => {
                    return element?.value?.name == airportField?.value?.name;
                  }) : ""}
                  onChange={handleAirportSelectChange}
                  placeholder={
                    serviceCityField?.value?.id
                      ? "Select airport"
                      : "Select city to select airport"
                  }
                  options={airportCityData}
                />
                <span style={{ color: "red" }}>
                  {errors?.airportDropdown?.message}
                </span>
              </div>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Tax</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={selectedTax}
                    onChange={(e) => {
                      console.log('selected tax',e)
                    setSelectedTax(e);
                    setValue("baseFareTax", e.value.baseTax, { shouldValidate: true });
                    setValue("serviceTax", e.value.serviceTax,{ shouldValidate: true });
                  }}
                  placeholder="Select Tax"
                  options={combinedTax}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.baseFareTax?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Initial Distance</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("initialDist", {
                  required: {
                    value: true,
                    message: "Initial Distance is required",
                  },
                  onChange: (e) => {
                    let value = e.target.value.replace(/[^\d.-]/g, "");
                    let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, "");
                    setValue("initialDist", sanitizedValue);
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.initialDist?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">
              Initial Distance Charge
            </Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("initialDistCharge", {
                  required: {
                    value: true,
                    message: "Initial Distance Charge is required",
                  },
                  onChange: (e) => {
                    let value = e.target.value.replace(/[^\d.-]/g, "");
                    let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, "");
                    setValue("initialDistCharge", sanitizedValue);
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.initialDistCharge?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Per Km Charge</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("perKmCharge", {
                  required: {
                    value: true,
                    message: "Per Km Charge is required",
                  },
                  validate: (value) => validatePerKmCharge(value, rewardConstraints),
                  onChange: (e) => {
                    let value = e.target.value.replace(/[^\d.-]/g, "");
                    let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, "");
                    setValue("perKmCharge", sanitizedValue);
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.perKmCharge?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">
              Waiting Fee (per minute)
            </Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("waitingChargePerMin", {
                  required: {
                    value: true,
                    message: "Waiting Fee is required",
                  },
                  onChange: (e) => {
                    let value = e.target.value.replace(/[^\d.-]/g, "");
                    let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, "");
                    setValue("waitingChargePerMin", sanitizedValue);
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.waitingChargePerMin?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">
              Free Waiting Time (minutes)
            </Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("waitingChargeAfterTimeInMin", {
                  required: {
                    value: true,
                    message: "Free Waiting Time is required",
                  },
                  onChange: (e) => {
                    let value = e.target.value.replace(/[^\d.-]/g, "");
                    let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, "");
                    setValue("waitingChargeAfterTimeInMin", sanitizedValue);
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.waitingChargeAfterTimeInMin?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">
              Waiting Charge Applies Below Speed (km/h)
            </Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("waitingCalcThresholdSpeed", {
                  required: {
                    value: true,
                    message: "Speed is required to calculate waiting charges.",
                  },
                  onChange: (e) => {
                    let value = e.target.value.replace(/[^\d.-]/g, "");
                    let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, "");
                    setValue("waitingCalcThresholdSpeed", sanitizedValue);
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.waitingCalcThresholdSpeed?.message}
              </span>
            </Col>
          </FormGroup>

          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Available From</Label>
            <Col lg="12">
              <InputGroup
                className="date"
                id="dt-minimum"
                data-target-input="nearest"
              >
                <DatePicker
                  className="form-control datetimepicker-input digits"
                  selected={applicableFromDateField.value}
                  // showTimeSelect
                  showYearDropdown
                  showMonthDropdown
                  scrollableYearDropdown
                  onChange={handleApplicableFromDate}
                  dateFormat="MMMM d yyyy"
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                />
              </InputGroup>
              <span style={{ color: "red" }}>
                {errors?.applicableFromDate?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Available To</Label>
            <Col lg="12">
              <InputGroup
                className="date"
                id="dt-minimum"
                data-target-input="nearest"
              >
                <DatePicker
                  className="form-control datetimepicker-input digits"
                  selected={applicableToDateField.value}
                  // showTimeSelect
                  showYearDropdown
                  showMonthDropdown
                  scrollableYearDropdown
                  onChange={handleApplicableToDate}
                  dateFormat="MMMM d yyyy"
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                />
              </InputGroup>
              <span style={{ color: "red" }}>
                {errors?.applicableToDate?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">
              Time From (Hours)
            </Label>
            <Col lg="12">
              <InputGroup
                className="date"
                id="dt-minimum"
                data-target-input="nearest"
              >
                <DatePicker
                  className="form-control datetimepicker-input digits"
                  selected={timeFromField.value}
                  onChange={handleTimeFrom}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={60}
                  timeCaption="Time"
                  dateFormat="hh:mm aa"
                  timeFormat="hh:mm aa"
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                />
              </InputGroup>
              <span style={{ color: "red" }}>{errors?.timeFrom?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Time To (Hours)</Label>
            <Col lg="12">
              <InputGroup
                className="date"
                id="dt-minimum"
                data-target-input="nearest"
              >
                <DatePicker
                  className="form-control datetimepicker-input digits"
                  selected={timeToField.value}
                  onChange={handleTimeTo}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={60}
                  timeCaption="Time"
                  dateFormat="hh:mm aa"
                  timeFormat="hh:mm aa"
                  // minTime={
                  //   timeFromField.value
                  //     ? new Date(0, 0, 0, new Date(timeFromField.value).getHours())
                  //     : new Date(0, 0, 0, 0, 0)
                  // }
                  // maxTime={new Date().setHours(23, 59)}
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                />
              </InputGroup>
              <span style={{ color: "red" }}>{errors?.timeTo?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup
            className="col-lg-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{ display: "flex", alignItems: "center" }}
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
            >
              <Input
                id="IsActive"
                type="checkbox"
                checked={isActiveField.value}
                onChange={(value) => isActiveField.onChange(value)}
              />
              <Label className="mb-0" for="IsActive">
                {"Available {Yes/No}"}
              </Label>
            </div>
          </FormGroup>
          {/* <FormGroup
            className="col-lg-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{ display: "flex", alignItems: "center" }}
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
            >
              <Input
                id="IsPriority"
                type="checkbox"
                checked={isPriorityField.value}
                onChange={(value) => isPriorityField.onChange(value)}
              />
              <Label className="mb-0" for="IsPriority">
                {"Is Priority"}
              </Label>
            </div>
          </FormGroup> */}
        </Row>
        <Row>
          <div
            style={{
              color: "#11BF5C",
              textDecoration: "underline",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setIsAdvanced(!isAdvanced)}
          >
            Advanced Configurations{" "}
            {isAdvanced ? (
              <ArrowUp
                style={{ width: "15px", height: "15px", marginLeft: "5px" }}
              />
            ) : (
              <ArrowDown
                style={{ width: "15px", height: "15px", marginLeft: "5px" }}
              />
            )}
          </div>
        </Row>
        {isAdvanced ? (
          <Row>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                Corporate Client
              </Label>
              <Col lg="12">
                <div className="city-select">
                  <CustomSelect
                    className="service-select"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={true}
                    value={
                      corporateClientField?.value?.id
                        ? corporateClientData.find((element) => {
                            return (
                              element?.value?.id ===
                              corporateClientField?.value?.id
                            );
                          })
                        : ""
                    }
                    isDisabled={serviceCityField?.value?.id ? false : true}
                    onChange={handleCorporateClientSelectChange}
                    placeholder={
                      serviceCityField?.value?.id
                        ? "Select Corporate Client"
                        : "Select city to select corporate client"
                    }
                    options={corporateClientData}
                  />
                </div>
                <span style={{ color: "red" }}>
                  {errors?.corporateClient?.message}
                </span>
              </Col>
            </FormGroup>
            {/* <FormGroup
              className="col-lg-3"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                style={{ display: "flex", alignItems: "center" }}
                className={
                  mix_background_layout == "dark-only"
                    ? "checkbox-dark p-0"
                    : "checkbox p-0"
                }
              >
                <Input
                  id="isNightfareTimeSlot"
                  type="checkbox"
                  checked={isNightfareTimeSlotField.value}
                  onChange={(value) => isNightfareTimeSlotField.onChange(value)}
                />
                <Label className="mb-0" for="isNightfareTimeSlot">
                  {"Is Night Fare"}
                </Label>
              </div>
            </FormGroup> */}
            {/* <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                Trip Time Charge Per Min
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  pattern="[0-9.]+"
                  {...register("tripTimeChargePerMin", {
                    onChange: (e) => {
                      let value = e.target.value.replace(/[^\d.-]/g, "");
                      let sanitizedValue = value.replace(
                        /(\.|\-)(?=.*\1)/g,
                        ""
                      );
                      setValue("tripTimeChargePerMin", sanitizedValue);
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.tripTimeChargePerMin?.message}
                </span>
              </Col>
            </FormGroup> */}
            {/* <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Discount Location Id</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("discountLocationId", {
                                })}
                            />
                        </Col>
                    </FormGroup> */}
          </Row>
        ) : null}

        <div style={{ display: "flex", justifyContent: "center",gap: "10px" }}>
          {/* <button
            type="submit"
            className="btn submit-button"
            disabled={isSubmitting}
          >
            {rateObj?.id ? "Update" : "Create"}
          </button> */}
          <button type="submit" className="btn submit-button" disabled={isSubmitting || (editingIndex === null && rateEntries.length >= MAX_ENTRIES)}>
            {editingIndex !== null ? "Update Rate" : "Add Rate"}
          </button>
          {editingIndex !== null && (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleCancelEdit}
          >
            Cancel Edit
          </button>
          )}
        </div>
      </Form>
    </div>
     {rateEntries.length > 0 && (
      <div style={{ marginTop: "30px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
          <h5>Added Rate Entries ({rateEntries.length})</h5>
          <Button
            onClick={submitAllRates}
            disabled={isSubmitting}
            variant="contained"
            color="primary"
          >
            {isSubmitting ? "Submitting..." : `Submit All ${rateEntries.length} Rate(s)`}
          </Button>
        </div>
    
        <div style={{ overflowX: "auto" }}>
          <table className="table table-bordered table-hover">
            <thead>
          <tr>
            <th>#</th>
            <th>Service City</th>
            <th>Car Type</th>
            <th>Initial Dist</th>
            <th>Initial Charge</th>
            <th>Per Km</th>
            <th>Ride Type</th>
            <th>Time From</th>
            <th>Time To</th>
            <th>Booking Source</th>
            <th>Active</th>
            {/* <th>Priority</th> */}
            <th>Actions</th>
          </tr>
            </thead>
          <tbody>
          {rateEntries.map((entry, index) => (
            <tr key={index} style={{ backgroundColor: editingIndex === index ? "#fff3cd" : "transparent" }}>
              <td>{index + 1}</td>
              <td>{entry.serviceCityName}</td>
              <td>{entry.carTypeName}</td>
              <td>{entry.initialDist}</td>
              <td>{entry.initialDistCharge}</td>
              <td>{entry.perKmCharge}</td>
              <td>{entry.rideType}</td>
              <td>{entry.timeFromDisplay}</td>
              <td>{entry.timeToDisplay}</td>
              <td>{entry.bookingSource}</td>
              <td>{entry.isActive ? "Yes" : "No"}</td>
              {/* <td>{entry.isPriority ? "Yes" : "No"}</td> */}
              <td>
                <div style={{ display: "flex", gap: "5px" }}>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => handleEditEntry(index)}
                    disabled={isSubmitting}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={() => handleRemoveEntry(index)}
                    disabled={isSubmitting}
                  >
                    Remove
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
      )} 
    </>
  )
}

export default MeterForms